import React from "react";

import { I3Column } from "../../../interfaces";
import { applyTransformations } from "../../../utils";
import { normalizeForTotal } from "../../../utils";
import ColImage from "../../utils/col-image";
import CmsMarkdown from "../../basic/cms-markdown";
import classNames from "classnames";
import SVG from "../../svg";

const defaultColWidth = 4;
const defaultAdminWidth = 0;

const Col3 = ({
  background_color,
  header_content,
  vertical_align,
  reverse_column_order,
  column_1,
  column_2,
  column_3,
  css_override,
  background_image,
  has_background_cutout
}: I3Column) => {
  const columns = normalizeForTotal([column_1, column_2, column_3], "width");
  const normalizedColumns = reverse_column_order === true ? columns.reverse() : columns;
  const cssOverrides = css_override?.add_classes;

  const classes = classNames(`cms-col-3`, cssOverrides, {
    section_background_cutout: has_background_cutout
  });

  const backgroundImage = background_image?.data?.attributes;

  const getBackgroundImage = () => {
    if (backgroundImage == null) return {};
    const { url } = backgroundImage;

    return {
      backgroundImage: `url(${applyTransformations(url, { w: 1700 })})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    };
  };

  return (
    <>
      {has_background_cutout && (
        <div style={{ height: "0px" }}>
          <SVG name="section-cutout" />
        </div>
      )}
      <div className={classes} style={getBackgroundImage()}>
        <div
          style={{ backgroundColor: background_color }}
          className={classNames("color-overlay", {
            "has-background-image": backgroundImage
          })}
        />

        <div className="container-wrapper py-6 container-lg col-sm-10 col-md-12 p-responsive height-full">
          {header_content && (
            <div className="text-center m-2 header-container">
              <CmsMarkdown content={header_content} />
            </div>
          )}
          <div
            className={`d-flex flex-column flex-md-row flex-justify-between height-full ${
              vertical_align === "Center" && "flex-md-items-center"
            }`}
          >
            {normalizedColumns.map((col) => {
              if (col == null) return null;
              const { name, id, width } = col;
              const colId = `${name.split(" ").join("-").toLowerCase()}-${id}`;
              const colWidth = width === defaultAdminWidth ? defaultColWidth : width;

              return (
                <div className={`col-md-${colWidth} ${colId} height-full`} key={colId}>
                  <div className="col-image-container container-lg padding-r height-full">
                    <ColImage {...col} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Col3;
